$(window).load(function () {
    var chart1 = new CanvasJS.Chart("chartContainer1", {
        creditHref: "",
        title: {
            text: "Largest Earthquakes by Richter Scale Magnitude",
            fontFamily: "Verdana",
            fontSize: 28
        },
        axisY2: {
            tickThickness: 0,
            lineThickness: 0,
            labelFontSize: 18,
            titleFontSize: 20,
            title: "Richter Scale Magnitude"
        },
        axisX: {
            interval: 1,
            gridThickness: 0,
            labelFontSize: 10,
            labelFontStyle: "normal",
            labelFontWeight: "normal",
            labelFontFamily: "Lucida Sans Unicode"
        },
        data: [{
            type: "bar",
            name: "Largest Earthquakes by Richter Scale Magnitude",
            axisYType: "secondary",
            color: "#014D65",
            toolTipContent: "{label}<br/>{name} Richter Scale Magnitude",
            dataPoints: [{
                label: "2010 Chile earthquake - February 27, 2010",
                name: "Bio-Bio, Chile  8.8",
                y: 8.8
            }, {
                label: "1906 Ecuador & Colombia earthquake - January 31, 1906",
                name: "Ecuador & Colombia  8.8",
                y: 8.8
            }, {
                label: "1762 Arakan earthquake - April 2, 1762",
                name: "Chittagong, Bangladesh (formerly Kingdom of Mrauk U)  8.8",
                y: 8.8
            }, {
                label: "1615 Arica earthquake - September 16, 1615",
                name: "Arica, Chile (formerly part of the Spanish Empire)  8.8",
                y: 8.8
            }, {
                label: "1833 Sumatra earthquake - November 25, 1833",
                name: "Sumatra, Indonesia (formerly part of the Dutch East Indies)  8.8 – 9.2 ",
                y: 8.82
            }, {
                label: "1611 Sanriku earthquake - December 2, 1611",
                name: "Pacific Ocean, Hokkaido, Japan  8.9",
                y: 8.9
            }, {
                label: "2011 Tōhoku earthquake - March 11, 2011",
                name: "Pacific Ocean, Tōhoku region, Japan  9.0",
                y: 9
            }, {
                label: "1952 Kamchatka earthquakes - November 4, 1952",
                name: "Kamchatka, Russian SFSR, Soviet Union  9.0",
                y: 9
            }, {
                label: "2004 Indian Ocean earthquake - December 26, 2004",
                name: "Indian Ocean, Sumatra, Indonesia  9.1 – 9.3",
                y: 9.1
            }, {
                label: "1964 Alaska earthquake - March 27, 1964",
                name: "Prince William Sound, Alaska, USA  9.2",
                y: 9.2
            }, {
                label: "1960 Valdivia earthquake - May 22, 1960",
                name: "Valdivia, Chile  9.5",
                y: 9.5
            }]
        }

        ]
    });

    var chart2 = new CanvasJS.Chart("chartContainer2", {
        creditHref: "",
        title: {
            text: "Largest Earthquakes by Death Toll",
            fontFamily: "Verdana",
            fontSize: 28
        },
        axisY2: {
            tickThickness: 0,
            lineThickness: 0,
            labelFontSize: 18,
            titleFontSize: 20,
            title: "Fatalities"
        },
        axisX: {
            interval: 1,
            gridThickness: 0,
            labelFontSize: 10,
            labelFontStyle: "normal",
            labelFontWeight: "normal",
            labelFontFamily: "Lucida Sans Unicode"
        },
        data: [{
            type: "bar",
            name: "flood events",
            axisYType: "secondary",
            color: "#014D65",
            toolTipContent: "{label}<br/>{name} Fatalities",
            dataPoints: [{
                label: "Kashmir, October 8, 2005",
                name: "Muzaffarabad, Pakistan  100,000",
                y: 100000
            }, {
                label: "Chihli, September 27, 1290",
                name: "Ningcheng, China  100,000",
                y: 100000
            }, {
                label: "Haiti, January 12, 2010",
                name: "Haiti  100,000 – 316,000",
                y: 100010
            }, {
                label: "Great Kantō, September 1, 1923",
                name: "Kantō region, Japan  105,385",
                y: 105385
            }, {
                label: "Ashgabat, October 6, 1948",
                name: "Turkmenistan (formally Ashgabat, Turkmen SSR)  110,000",
                y: 110000
            }, {
                label: "Messina, December 28, 1908",
                name: "Messina, Italy  123,000",
                y: 123000
            }, {
                label: "Aleppo, November 29, 533",
                name: "Syria  130,000",
                y: 130000
            }, {
                label: "Ardabil, March 22, 893",
                name: "Ardabil, Iran  150,000",
                y: 150000
            }, {
                label: "Damghan, December 22, 856",
                name: "Damghan, Iran  200,000",
                y: 200000
            }, {
                label: "Aleppo, October 11, 1138",
                name: "Aleppo, Syria  230,000",
                y: 230000
            }, {
                label: "Indian Ocean, December 26, 2004",
                name: "Indian Ocean, Sumatra, Indonesia  230,210",
                y: 230210
            }, {
                label: "Antioch, May 21, 526",
                name: "Antioch, Turkey (formerly Byzantine Empire)  240,000",
                y: 240000
            }, {
                label: "Tangshan, July 28, 1976",
                name: "Hebei, China  242,769",
                y: 242769
            }, {
                label: "Haiyuan, December 16, 1920",
                name: "Ningxia–Gansu, China  273,400",
                y: 273400
            }, {
                label: "Shaanxi, January 23, 1556",
                name: "Shaanxi, China  820,000 – 830,000",
                y: 825000
            }]
        }

        ]
    });

    var chart3 = new CanvasJS.Chart("chartContainer3", {
        creditHref: "",
        title: {
            text: "Largest Modern Day Earthquakes by Property Damage Value"
        },
        axisY2: {
            tickThickness: 0,
            lineThickness: 0,
            labelFontSize: 18,
            titleFontSize: 20,
            title: "Billions of Dollars"
        },
        axisX: {
            interval: 1,
            gridThickness: 0,
            labelFontSize: 10,
            labelFontStyle: "normal",
            labelFontWeight: "normal",
            labelFontFamily: "Lucida Sans Unicode",
            labelMaxWidth: 80
        },
        data: [{
            type: "bar",
            axisYType: "secondary",
            color: "#014D65",
            toolTipContent: "{label}<br/>{name} Billion",
            dataPoints: [{
                label: "Taiwan 1999",
                name: "Taiwan earthquake  $10",
                y: 10
            }, {
                label: "United States 1989",
                name: "Loma Prieta earthquake  $11",
                y: 11
            }, {
                label: "Italy 2012",
                name: "Emilia earthquakes  $13.2",
                y: 13.2
            }, {
                label: "Chile 2010",
                name: "Chile earthquake  $15–30",
                y: 15
            }, {
                label: "United States 1994",
                name: "Northridge earthquake  $20",
                y: 20
            }, {
                label: "New Zealand 2011",
                name: "Christchurch earthquake  $40",
                y: 40
            }, {
                label: "China 2008",
                name: "Sichuan earthquake  $75",
                y: 75
            }, {
                label: "Japan 1995",
                name: "Great Hanshin earthquake  $100",
                y: 100
            }, {
                label: "Japan 2011",
                name: "Tōhoku earthquake  $235",
                y: 253
            }]
        }

        ]
    });

    chart1.render();
    chart2.render();
    chart3.render();
});